import { render, staticRenderFns } from "./OfferAllIndex.vue?vue&type=template&id=230108ff"
import script from "./OfferAllIndex.vue?vue&type=script&lang=js"
export * from "./OfferAllIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports